<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="500px"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span v-if="item.id">Cập nhật dữ liệu</span>
        <span v-else>Thêm mới</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div v-if="errors_exist" class="row">
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="item.ngay_cap_nhat"
                label="Ngày cập nhật"
                class="require"
                placeholder="dd/mm/yyyy"
                v-mask="'##/##/####'"
                autofocus
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="productSelected"
                :items="products"
                item-text="name"
                item-value="id"
                label="Mặt hàng"
                class="require"
                return-object
                append-outer-icon="mdi-plus"
                @click:append-outer="showDialogProduct"
                hide-details
              >
                <template v-slot:prepend-item>
                  <div class="filter-append">
                    <v-text-field 
                      label="Tìm" 
                      outlined
                      dense
                      @input="productFilter"
                      append-icon="mdi-filter-variant"
                      placeholder="Nhập tên mặt hàng"
                      clearable
                      class="px-3"
                      hide-details
                    />
                  </div>
                </template>
                <template
                  slot="item"
                  slot-scope="data"
                >
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content v-text="data.item"/>
                  </template>
                  <template v-else>
                    <v-list-item-content style="max-width: 400px;">
                      <v-list-item-title 
                        v-html="data.item.name"
                        :title="data.item.name"
                      />
                    </v-list-item-content>
                  </template>
                </template>
              </v-select>
              <FormProduct 
                :showDialog="dialogProduct" 
                :item="itemProduct" 
                @confirmed="onConfirmed" 
                @cancelled="onCancelled"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="initialLPriceFormatted"
                @keypress="isNumber($event)"
                label="Giá thấp"
                class="require"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="initialHPriceFormatted"
                @keypress="isNumber($event)"
                label="Giá cao"
                class="require"
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="4"
            >
              <v-checkbox
                v-model="checkOtherArea"
                label="Ngoài tỉnh?"
                color="green"
                hide-details
              />
            </v-col>
            <v-col
              v-if="checkOtherArea"
              cols="12"
              sm="6"
              md="8"
            >
              <v-autocomplete
                v-model="areaSelected"
                :items="areas"
                :loading="areas.length ? false: true"
                color="blue-grey lighten-2"
                label="Khu vực"
                item-text="name"
                item-value="maqh"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.daumoi"
                label="Đầu mối, Hiệp hội ..."
                hide-details
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small><span class="pink--text">(*)</span> bắt buộc nhập</small>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="save(item)"
        >
          Lưu lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import FormProduct from '@/views/admin/markets/products/Form';
  import { mapActions } from 'vuex';
  function formatAsCurrency (value, dec) {
    dec = dec || 0;
    if (value === null) {
      return '';
    }
    return '' + parseFloat(value).toFixed(dec).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  }
  export default {
    components: { 
      FormProduct
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object
      }
    },
    data () {
      return {
        loading: false,
        dialog: false,
        errors_exist: false,
        errors: [],
        products: [],
        productSelected: null,
        money: {
          decimal: ',',
          thousands: ',',
          precision: 3,
          masked: false
        },
        dialogProduct: false,
        itemProduct: {},
        checkOtherArea: false,
        areas: [],
        areaSelected: null,
        initialAmount: null,
        initialLPrice: null,
        initialHPrice: null
      }
    },
    mounted() {
      this.dialog = this.showDialog;
      this.getProductTypes();
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist=false;
        if (this.showDialog) {
          this.dialog = true;
          this.initialAmount = null;

          if(this.item.mathang_id) {
            this.productSelected = this.products.find(
              element => element.id == this.item.mathang_id
            );
          }
          if(this.item.khu_vuc){
            this.checkOtherArea = true;
          }
          if(this.item.l_price){
            this.initialLPrice = this.item.l_price;
          }
          if(this.item.h_price){
            this.initialHPrice = this.item.h_price;
          }
        }
      },
      checkOtherArea(){
        if(this.checkOtherArea){
          this.getAreas();
        } else {
          this.areaSelected = null;
        }
      }
    },
    computed: {
      initialAmountFormatted: {
        get: function() {
          return formatAsCurrency(this.initialAmount, 0);
        },
        set: function(newValue) {
          this.initialAmount = Number(newValue.replace(/[^0-9\.]/g, ''));
        }
      },
      initialLPriceFormatted: {
        get: function() {
          return formatAsCurrency(this.initialLPrice, 0);
        },
        set: function(newValue) {
          this.initialLPrice = Number(newValue.replace(/[^0-9\.]/g, ''));
        }
      },
      initialHPriceFormatted: {
        get: function() {
          return formatAsCurrency(this.initialHPrice, 0);
        },
        set: function(newValue) {
          this.initialHPrice = Number(newValue.replace(/[^0-9\.]/g, ''));
        }
      },
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      getAreas () {
        axios.get("api/v1/provinces")
          .then(response => {
            this.areas = response.data;
            // if has id khu vuc
            this.areaSelected = this.areas.find(
              element => element.matp == this.item.khu_vuc
            );
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      showDialogProduct(){
        this.itemProduct = {};
        this.dialogProduct = true;
      },
      onConfirmed(item) {
        this.dialogProduct = false;
        this.products.push(item);
      },
      onCancelled () {
        this.dialogProduct = false;
      },
      close() {
        this.checkOtherArea=false;
        this.productSelected=null;
        this.areaSelected=null;
        this.dialog = false;
        this.$emit('cancelled');
      },
      save(item) {
        const app = this;
        let method = "post";
        let url = `api/v1/market-prices`;
        let data = item;

        if(app.productSelected){
          data.mathang_id = app.productSelected.id;
        }
        
        data.l_price = app.initialLPrice;
        data.h_price = app.initialHPrice;
        
        if (data.id) {
          method = "patch";
          url = `api/v1/market-prices/${data.id}`;
        }

        app.loading=true;

        axios[method](url, data)
          .then((response) => {
            if (response.data && response.data.id) {
              app.$emit('confirmed', response.data);
            }
            app.loading=false;
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.loading=false;
            app.openSnackbar({ type: 'error' });
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      },
      search(val) {
        if (!val) { this.getAreas(); }
        else {
          let results = [];
          this.areas.forEach(function(v,i){
            if(v.name.toLowerCase().includes(val.toLowerCase())){
              results.push(v);
            }
          });
          if(results.length){
            this.areas=results;
          }
        }
      },
      productFilter(val) {
        const app = this;
        if (!val) {
          app.getProductTypes(); 
        } else {
          let results = [];
          app.products.forEach(function(prod){
            if(typeof prod === 'object') {
              let productName = app.$helpers.sanitizeTitle(prod.name).toLowerCase();
              let keyword = app.$helpers.sanitizeTitle(val).toLowerCase();
              if(productName.includes(keyword)){
                results.push(prod);
              }
            }
          });
          if(results.length){
            app.products=results;
          }
        }
      },
      getProductTypes () {
        const app = this;
        app.products = [];
        axios.get("api/v1/market-prod-types")
          .then(response => {
            response.data.forEach(type => {
              app.products.push({
                header: type.name
              });
              if(type.market_products){
                type.market_products.forEach(prod => {
                  app.products.push({
                    name: prod.name,
                    id: prod.id
                  });
                });
              }
            });
          })
          .catch(function (error) {
            app.openSnackbar({ 
              type: 'error',
              body: 'Lấy nhóm giá không thành công!'
            });
          });
      },
    }
  }
</script>
<style scoped>
  .filter-append{
    position:sticky;
    top: 0;
    padding-top: 8px;
    padding-bottom: 8px;
    width:100%;
    display:flex;
    justify-content :center;
    background :white;
    z-index: 1;
  }
</style>